export type CraftRow = {
	CraftId: number | null;
	CraftName: string;
	Code: string | null;
	Color: string;
	WorkOrderCount?: number;
	TemplateCount?: number;
};

export type ModalMode = "new" | "edit" | "delete" | "";

// ColorBrewer "Paired": the family the existing crafts already use (Electrical, Mechanical,
// Hydraulic, Cranes), in light/dark pairs per hue. Its unreadable yellow is replaced by the
// blue grey Safety is seeded with, and its light pink by a teal. The light tones stay because
// crafts use them, but the white badge letter is hard to read on them, so new crafts start on
// a dark tone.
export const CRAFT_COLORS = [
	"#a6cee3",
	"#1f78b4",
	"#b2df8a",
	"#33a02c",
	"#00796b",
	"#e31a1c",
	"#fdbf6f",
	"#ff7f00",
	"#cab2d6",
	"#6a3d9a",
	"#b15928",
	"#455a64",
];

export const CRAFT_INITIAL_VALUES: CraftRow = {
	CraftId: null,
	CraftName: "",
	Code: "",
	Color: "#6a3d9a",
};
